const AUTH = {
  type() {
    if (localStorage.type == "USR1500") {
      return "Teacher";
    } else if (localStorage.type == "USR2100") {
      return "Student";
    } else if (localStorage.type == "USR") {
      return "Market";
    } else {
      return undefined;
    }
  },

  isLoggedIn(type = "user") {
    if (type == "user") {
      return (
        localStorage.isLoggedIn != undefined &&
        localStorage.isLoggedIn == "true"
      );
    } else if (type == "seller") {
      return (
        localStorage.isLoggedInSeller != undefined &&
        localStorage.isLoggedInSeller == "true"
      );
    }
  },
  teacherOrStudent() {
    return (
      localStorage.isLoggedIn != undefined &&
      localStorage.isLoggedIn == "true" &&
      (localStorage.type == "USR1500" || localStorage.type == "USR2100")
    );
  },
  getID(type = "user") {
    if (type == "user") {
      return localStorage.id != undefined ? localStorage.id : null;
    } else {
      return localStorage.seller_id != undefined
        ? localStorage.seller_id
        : null;
    }
  }
};

export default AUTH;
